// Widget scripts
import cardWidget from './js/widgets/cardWidget.js';
import hotbuttons from './js/widgets/hotbuttons.js';
import cardWidgetTiles from './js/widgets/cardWidgetTiles.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetSeo from './js/widgets/cardWidgetSeo.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
import cardWidgetLink from './js/widgets/cardWidgetLink.js';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget(); 
    cardWidgetTiles();
   hotbuttons();  

   cardWidgetSeo();
//infocards();
   multiScheduleFeature();
   sponsorWidgetContainer();
   cardWidgetLink();
  });
}